var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHairG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 189,
    viewBox: "0 0 132 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66626 91.7501L0 70.3443C0 47.1445 12.8295 17.2577 19.5652 13.0409C48.6316 -5.15572 82.8722 -3.65571 112.902 13.4725C121.396 18.3178 132 56.3441 132 70.3443L129.949 91.4192C128.712 90.404 127.238 89.6576 125.497 89.2371C125.531 87.8893 125.549 86.527 125.549 85.1505C125.549 38.768 105.867 13.8443 65.9999 13.8443C26.1331 13.8443 6.45108 38.768 6.45108 85.1505C6.45108 86.527 6.46841 87.8893 6.50309 89.2372C4.57796 89.7021 2.97873 90.5654 1.66626 91.7501Z",
    className: "Hair"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 126.838V188.766C22.3163 185.289 33.2523 181.714 43 178.87V157.975C29.0177 152.503 19.0245 141.656 12.9759 126.679C12.6535 126.74 12.3281 126.794 12 126.838ZM119 188.946V126.738C112.806 142.039 102.488 153.022 88 158.354V179.105C97.7972 181.959 108.72 185.507 119 188.946Z",
    className: "HairDark"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.029 188.956C119.054 178.166 119.092 168.152 119.127 158.859C119.172 147.012 119.212 136.336 119.216 126.714C119.152 126.703 119.088 126.691 119.024 126.678C113.634 140.024 105.112 150.092 93.4258 155.997C95.0298 166.017 96.8714 174.864 98.9282 182.417C105.583 184.501 112.438 186.751 119.029 188.956Z",
    className: "Hair"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1174 155.231C26.1774 149.24 18.1395 139.464 12.9762 126.679C12.7416 126.724 12.5055 126.764 12.268 126.8C12.0643 143.906 12.0156 164.344 12.0039 188.764C18.4932 186.577 25.2276 184.352 31.7571 182.293C33.7783 174.575 35.5704 165.511 37.1174 155.231Z",
    className: "Hair"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.321 26.5386C87.1959 35.9598 47.0446 36.5941 29.285 26.5386C22.5895 22.7476 43.0818 2.84429 67.0204 2.8443C81.019 2.84431 111.451 20.8521 102.321 26.5386Z",
    className: "Hair"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHairG);
export default __webpack_public_path__ + "static/media/Hair G.4d4ee51a9bffe8dc060843dbb7ab6095.svg";
export { ForwardRef as ReactComponent };